var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIngredientsCostRate = function SvgIngredientsCostRate(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 32,
    height: 32
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "ingredientsCostRate_svg__a",
    d: "M8.558 16c-2.3 0-4.105-2.925-4.105-6.666 0-3.74 1.79-6.65 4.105-6.65 2.314 0 4.104 2.925 4.104 6.665S10.857 16 8.558 16m0-12.21c-1.63 0-2.999 2.546-2.999 5.559s1.369 5.545 2.999 5.545 2.998-2.547 2.998-5.545-1.383-5.56-2.998-5.56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ingredientsCostRate_svg__b",
    d: "M13.302 16c-.99 0-1.936-.553-2.678-1.572a.544.544 0 0 1 .131-.771.557.557 0 0 1 .771.13c.364.51.976 1.121 1.776 1.121 1.63 0 2.998-2.546 2.998-5.544 0-2.999-1.368-5.56-2.998-5.56-.771 0-1.368.568-1.717 1.048a.54.54 0 0 1-.772.102.54.54 0 0 1-.102-.772c.728-.96 1.645-1.484 2.606-1.484 2.299 0 4.104 2.925 4.104 6.666 0 3.74-1.82 6.636-4.119 6.636m-9.198 0C1.804 16 0 13.075 0 9.334 0 5.594 1.805 2.67 4.104 2.67c.96 0 1.878.524 2.605 1.484a.55.55 0 0 1-.102.772.55.55 0 0 1-.771-.102c-.364-.48-.946-1.048-1.717-1.048-1.63 0-2.998 2.547-2.998 5.56s1.368 5.544 2.998 5.544c.8 0 1.411-.61 1.775-1.12a.557.557 0 0 1 .772-.131.557.557 0 0 1 .13.771C6.055 15.447 5.095 16 4.105 16M8.69 3.47H8.63a.55.55 0 0 1-.495-.597c.088-.874.772-2.59 2.81-2.867a.557.557 0 1 1 .145 1.106c-1.688.218-1.848 1.79-1.848 1.863a.55.55 0 0 1-.553.494"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "ingredientsCostRate_svg__c",
    width: 8.608,
    height: 13.717,
    x: -0.2,
    y: -0.2,
    maskContentUnits: "userSpaceOnUse",
    maskUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M4.253 2.483h8.608V16.2H4.253z"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ingredientsCostRate_svg__a"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "ingredientsCostRate_svg__d",
    width: 17.821,
    height: 16.4,
    x: -0.2,
    y: -0.2,
    maskContentUnits: "userSpaceOnUse",
    maskUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M-.2-.2h17.821v16.4H-.2z"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ingredientsCostRate_svg__b"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#14864D",
    d: "M6 0h20a6 6 0 0 1 6 6v20a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6V6a6 6 0 0 1 6-6"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#FFF",
    stroke: "#FFF",
    strokeDasharray: "0,0",
    strokeWidth: 0.4,
    transform: "translate(8 8)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ingredientsCostRate_svg__a",
    mask: "url(#ingredientsCostRate_svg__c)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ingredientsCostRate_svg__b",
    mask: "url(#ingredientsCostRate_svg__d)"
  })))));
};
export default SvgIngredientsCostRate;